import apiFinancial from "../config/api_financial";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

function findAllFinancialParametersByGroupIdAndFarmId(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/parameters`,
    getHeaders(false, signal)
  );
}

export { findAllFinancialParametersByGroupIdAndFarmId };
